export default __webpack_public_path__ + "static/media/5cbadae7-7142-4736-ac71-fa8ae1545390.e85bd38e.jpg";